// @flow
import { FREE_BUSY_MEETING_URL } from 'constants/externalUrls';

export default class FreeBusyDecorator {
  static meetingUrl(meetingId: string): string {
    return `${FREE_BUSY_MEETING_URL}/${meetingId}`;
  }
};
